import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import {
  BiData,
  BiContextProvidedValue,
  UserNameClickBiEvent,
} from '@wix/da-bi/pkg/events';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import UserGrid from '../../_partials/UserGrid';

export interface Visitor extends PapiUser {
  isLoggedin: boolean;
}

export interface Props {
  moduleId: number;
  seeAllUrl: string;
  browseUrl: string;
  username: string;
  visitor: Visitor;
  deviants: PapiUser[];
  isHeaderStickyOnMobile?: boolean;
}

export const WatchedDeviants: React.FC<Props> = ({ deviants }) => {
  const logEvent = useBiLogger();

  return (
    <UserGrid
      users={deviants}
      onUserClick={user => {
        logEvent(
          BiData<UserNameClickBiEvent>({
            evid: 101,
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: ResourceType.USER,
            itemid: user.userId,
          })
        );
      }}
    />
  );
};

export default WatchedDeviants;
